// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.interactive-table-head__header {
  border-right: 1px solid var(--color-border-base);
  border-bottom: 1px solid var(--color-border-base);
  background: var(--color---color-background-layer-2);
  height: 35px;
  padding-right: 18px;
}
.interactive-table-head__header:first-child {
  padding-right: 0;
}
.interactive-table-head__resizer {
  width: 4px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  transform: translateX(50%);
  z-index: 1;
  touch-action: none;
}
.interactive-table-head__sort {
  position: absolute;
  top: 50%;
  right: 2px;
  transform: translateY(-50%);
  z-index: 1;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/common/ui/interactive-table/InteractiveTableHead.less"],"names":[],"mappings":"AAIE;EACE,gDAAA;EACA,iDAAA;EACA,mDAAA;EACA,YAAA;EACA,mBAAA;AAHJ;AAKI;EACE,gBAAA;AAHN;AAOE;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,0BAAA;EACA,UAAA;EACA,kBAAA;AALJ;AAQE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;EACA,UAAA;AANJ","sourcesContent":[".interactive-table-head {\n  @headerHeight: 35px;\n  @resizerWidth: 4px;\n\n  &__header {\n    border-right: 1px solid var(--color-border-base);\n    border-bottom: 1px solid var(--color-border-base);\n    background: var(--color---color-background-layer-2);\n    height: @headerHeight;\n    padding-right: 16px + (@resizerWidth / 2);\n\n    &:first-child {\n      padding-right: 0;\n    }\n  }\n\n  &__resizer {\n    width: @resizerWidth;\n    height: 100%;\n    position: absolute;\n    right: 0;\n    top: 0;\n    transform: translateX(50%);\n    z-index: 1;\n    touch-action: none;\n  }\n\n  &__sort {\n    position: absolute;\n    top: 50%;\n    right: (@resizerWidth / 2);\n    transform: translateY(-50%);\n    z-index: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
